
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Quel est le navigateur le plus sûr en 2026 ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez quel navigateur est le plus sûr pour une navigation en ligne sans risques. Comprend des conseils pour protéger votre vie privée et vos données.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Quel est le navigateur le plus sûr en 2026 ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez quel navigateur est le plus sûr pour une navigation en ligne sans risques. Comprend des conseils pour protéger votre vie privée et vos données.",
        },
      ],
    };
  },
};
